import { FeaturesService } from "@app/services/Features.service";
import { Inject, Injectable } from "@angular/core";

export type Timer = { stop: (conclusion: string) => void }
export const NoopTimer = {
    stop: (conclusion: string) => { console.error(new Error(`TimerStopper not present to stop for ${conclusion}`).stack) }
}

export const CATEGORIES = {
    FTNI: 'FTNI Call'
}

export const CATEGORIES_ARR = Object.keys(CATEGORIES).map(k => CATEGORIES[k])

/**
 * Google Analytics timing
 */
@Injectable({ providedIn: "root" })
export class UserTimingService {
    constructor(@Inject(FeaturesService) private featuresService: FeaturesService) {}

    static noopTimer = NoopTimer

    /**
     * startTimer adds a task to the queue
     * @param category Google Analytics timing category
     * @param name Google Analytics timing name
     * @param description User friendly display value if we needed to inform the user what is happening
     */
    startTimer(category: string, name: string, description: string): Timer {
        if (CATEGORIES_ARR.indexOf(category) === -1) {
            console.error(new ReferenceError(`Category "${category}" is not a registered event category`).stack)
            return { stop: function () { } }
        }

        const startedAt = Date.now()
        let hasBeenStopped = false

        // return stop function
        return {
            stop: conclusion => {
                // ensure it isn't called more than once
                if (hasBeenStopped) return console.error('Timer has already been stopped');
                hasBeenStopped = true;

                const durationMs = Date.now() - startedAt
                if (!window.__karma__) console.log('%cTiming Complete', 'color: gray; font-style: italic', { name, category, conclusion, durationMs })

                if (this.featuresService.isEnabled("ANALYTICS")) {
                    gtag('event', 'timing_complete', {
                        'name': name,
                        'value': durationMs,
                        'event_category': category,
                        'event_label': conclusion
                    })
                }
            }
        }
    }
}
